import { useEffect, useState } from 'react';
import { useAuth } from 'hooks/useAuth';
import { useNavigate } from 'react-router';

type useModalHasActiveUserProps = {
	handleLogout: () => void;
	activeSession: boolean | null;
};

export const useModalHasActiveUser = ({
	activeSession,
	handleLogout,
}: useModalHasActiveUserProps) => {
	const { signOut } = useAuth();
	const navigate = useNavigate();
	const timeQuitSession = Number(import.meta.env.VITE_TIME_QUIT_SESSION);
	const [modalMessage, setModalMessage] = useState({
		title: '',
		message: '',
		button: '',
	});

	const [timer, setTimer] = useState<string>();

	useEffect(() => {
		setModalMessage(
			activeSession === false
				? {
						title: '¿Aún estás ahí?',
						message: `Cerraremos tu sesión por inactividad en ${timer} minutos.`,
						button: 'Continuar activo',
				  }
				: activeSession === null
				? {
						title: '',
						message: 'Se cerró tu sesión por inactividad.',
						button: 'OK',
				  }
				: { title: '', message: '', button: '' },
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeSession, timer]);

	useEffect(() => {
		const interval = setInterval(() => {
			signOut();
			handleLogout();
			navigate('/login');
		}, timeQuitSession);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const duration = timeQuitSession / 1000;
		let timer = duration,
			minutes,
			seconds;

		minutes = Math.floor(timer / 60);
		seconds = Math.floor(timer % 60);
		minutes = minutes < 10 ? '0' + minutes : minutes;
		seconds = seconds < 10 ? '0' + seconds : seconds;
		setTimer(minutes + ':' + seconds);

		const chronometer = setInterval(() => {
			minutes = Math.floor(timer / 60);
			seconds = Math.floor(timer % 60);
			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;
			if (--timer < 0) {
				timer = duration;
			}
			setTimer(minutes + ':' + seconds);
		}, 1000);
		return () => clearInterval(chronometer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { modalMessage };
};
